import React from "react";
import SigninForm from "components/auth/authForm/SigninForm";
import AuthSidebar from "components/auth/authSidebar/AuthSidebar";
import Footer from "components/footer/Footer";
import AuthLayout from "layouts/AuthLayout";

import { Box, Grid } from "@mui/material";
import { styles } from "./index.styles";

const Signin = () => {
  return (
    <AuthLayout>
      <Box sx={styles.section}>
        <Grid container sx={styles.container}>
          <CornerImage />
          <AuthSidebar />
          <SigninForm />
        </Grid>
        {/* TODO: https://app.clickup.com/t/85zu48gu1 */}
        {/* <div className="hidden-md"> */}
        <div>
          <Footer />
        </div>
      </Box>
    </AuthLayout>
  );
};

export default Signin;

const CornerImage = () => {
  return <img src="../../auth/animal.png" alt="" style={styles.image} />;
};
